module.exports = __webpack_public_path__ + "img/biao1.685666e0.png";